// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataStreamListItem } from './data-stream-list-item';
import {
    DataStreamListItemFromJSON,
    DataStreamListItemFromJSONTyped,
    DataStreamListItemToJSON,
    DataStreamListItemToJSONTyped,
} from './data-stream-list-item';

/**
 * 
 * @export
 * @interface ListDataStreamsResponseContent
 */
export interface ListDataStreamsResponseContent {
    /**
     * 
     * @type {Array<DataStreamListItem>}
     * @memberof ListDataStreamsResponseContent
     */
    dataStreams: Array<DataStreamListItem>;
    /**
     * 
     * @type {string}
     * @memberof ListDataStreamsResponseContent
     */
    nextToken?: string;
}

/**
 * Check if a given object implements the ListDataStreamsResponseContent interface.
 */
export function instanceOfListDataStreamsResponseContent(value: object): value is ListDataStreamsResponseContent {
    if (!('dataStreams' in value) || value['dataStreams'] === undefined) return false;
    return true;
}

export function ListDataStreamsResponseContentFromJSON(json: any): ListDataStreamsResponseContent {
    return ListDataStreamsResponseContentFromJSONTyped(json, false);
}

export function ListDataStreamsResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDataStreamsResponseContent {
    if (json == null) {
        return json;
    }
    return {
        
        'dataStreams': ((json['dataStreams'] as Array<any>).map(DataStreamListItemFromJSON)),
        'nextToken': json['nextToken'] == null ? undefined : json['nextToken'],
    };
}

export function ListDataStreamsResponseContentToJSON(json: any): ListDataStreamsResponseContent {
    return ListDataStreamsResponseContentToJSONTyped(json, false);
}

export function ListDataStreamsResponseContentToJSONTyped(value?: ListDataStreamsResponseContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dataStreams': ((value['dataStreams'] as Array<any>).map(DataStreamListItemToJSON)),
        'nextToken': value['nextToken'],
    };
}
